export const scrollElementIntoViewById = (
  id: string,
  position: ScrollLogicalPosition = 'center',
  delay = 350 // Accounts for delay for animation
) => {
  requestAnimationFrame(() =>
    setTimeout(() => {
      document.querySelector(`#${id}`)?.scrollIntoView({behavior: 'smooth', block: position});
    }, delay)
  );
};
